import {
    instance as axios,
    setJwtToken,
    setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------donation-listing--------------------------
export const donationListApi = async (data) => {
    const endPoint =
        `donation/list` +
        "?" +
        new URLSearchParams({ ...data }).toString();

    return await axios.get(endPoint, setJwtToken());
};